import gql from 'graphql-tag';
import { OrderListItem } from '../fragments';

export default gql`
mutation adminModifyOrder (
    $id: ID!
    $is_admin_checked: Boolean
) {
    adminModifyOrder (input: {id: $id, is_admin_checked: $is_admin_checked}) {
        ...OrderListItem
    }
}
${OrderListItem}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/adminModifyOrder.ts